import $ from "jquery";
const API_ENDPOINT ="https://xelestech.com";


let strWearingList;

window.updateInventoryWearingList = function(visualItemInventory, wearingList) {
    let newAttrList = [];
    for (const [key, value] of visualItemInventory.entries()) {        
        let obj = {
            name: key,
            child: value
        }
        newAttrList.push(obj)
    }
    for (let i = 0; i < newAttrList.length; i++) {
        for (let x = 0; x < newAttrList[i].child.length; x++) {  
            let level2 = newAttrList[i].child;
            let class1 = "";
    
            let level2ImgName = level2[x].name;
            for (const [key, value] of wearingList.entries()) {
                if (key === newAttrList[i].name) {
                    $(`[data-inventory-equid-list="${newAttrList[i].name}"]`)[0].innerHTML = "";
                    $($(`[data-inventory-equid-list="${newAttrList[i].name}"]`)[0]).append(`<img src="${API_ENDPOINT}/assets/inventory/acc/${value.name}.png">`);
                    $(`[data-inventory-list-child="${value.name}"]`).click()
                }
            }
        }
    }
};



window.initInventory = function(visualItemInventory,wearingList){

let html = `    <div class="inventory-wrapper hide">
<div class="inventory-container">
    <img class="inventory-container-close" src="https://xelestech.com/assets/inventory/icon_inventory_close.png">

    <div class="inventory-left">
        <div class="inventory-left__container">
            <div id="inventory-left-item-list-1" class="inventory-left__character-item__wrapper">
            </div>
            <div class="inventory-left__character-model__wrapper">
                <img class="inventory-left__character-model__wrapper-bgimg" src="https://xelestech.com/assets/inventory/bg_round_light.png">
                <div class="inventory-left__character-model-iframe__wrapper"><iframe id="MyFrame" class="inventory-left__character-model-iframe" src="https://xelestech.com/townhubiframe/index.html"></iframe></div>
            </div>
            <div id="inventory-left-item-list-2"class="inventory-left__character-item__wrapper">
            </div>
        </div>

        <img class="inventory-left__character-model__bg-img" src="https://xelestech.com/assets/inventory/character_ground.png">
    </div>
    <div class="inventory-right__wrapper">
        <div class="invertory-right__tabs-wrapper">
            <div class="invertory-right__tabs-container">
            </div>
            <div class="inventory-right__tab-arrow__wrapper"> 
                <div class="inventory-right__tab-arrow__fake"></div>
                <img class="invertory-right__tab-arrow left" data-val="left" src='https://xelestech.com/assets/inventory/icon_inventory_arrow_left.png'>
            </div>
            <div class="inventory-right__tab-arrow__wrapper right"> 
                <div class="inventory-right__tab-arrow__fake"></div>
                <img class="invertory-right__tab-arrow right" data-val="right" src='https://xelestech.com/assets/inventory/icon_inventory_arrow_right.png'>
            </div>

        </div>
        <div class="inventory-right__items-wrapper">
        </div>

    </div>
</div>
</div>`
$('body').append(html);


document.getElementById('MyFrame').onload = function() {
    initSendDataToPhaser(wearingList);  
};

let attrList = [];

for (const [key, value] of visualItemInventory.entries()) {        
    let obj = {
        name: key,
        child: value
    }
    attrList.push(obj)
}


function replacer(key, value) {
    if(value instanceof Map) {
      return {
        dataType: 'Map',
        value: Array.from(value.entries()), // or with spread: value: [...value]
      };
    } else {
      return value;
    }
  }

  function reviver(key, value) {
    if(typeof value === 'object' && value !== null) {
      if (value.dataType === 'Map') {
        return new Map(value.value);
      }
    }
    return value;
  }



function initAttrListRender() {
    strWearingList = JSON.stringify(wearingList, replacer);

    for (let i = 0; i < attrList.length; i++) {
        //render accesories tab
        $('.invertory-right__tabs-container').append(`<div class="invertory-right__tab-child" data-attr="${attrList[i].name}" >${attrList[i].name}</div>`);

        
        let div = `<div class="inventory-right__items-container" data-inventory-list="${attrList[i].name}">`;

        for (let x = 0; x < attrList[i].child.length; x++) {                 
            let level2 = attrList[i].child;
            let class1 = "";
    
            let level2ImgName = level2[x].name;
            for (const [key, value] of wearingList.entries()) { 

                if (key === attrList[i].name) {
                    if (value.name === attrList[i].child[x].name) {
                        class1 = "selected"              
                        $(`[data-inventory-equid-list="${attrList[i].name}"]`)[0].innerHTML = "";
                        $($(`[data-inventory-equid-list="${attrList[i].name}"]`)[0]).append(`<img src="${API_ENDPOINT}/assets/inventory/acc/${value.name}.png">`)
                    }  
                }
            }
            div += 
                `<div class="inventory-right__items-child ${class1}" data-inventory-list-child="${level2ImgName}">
                    <img class="inventory-right__items-child__close" src="${API_ENDPOINT}/assets/inventory/icon_inventory_close.png"> 
                    <img class="inventory-right__items-child__img" src="${API_ENDPOINT}/assets/inventory/acc/${level2ImgName}.png">
                </div>`;
            }

        $('.inventory-right__items-wrapper').append(div);
    }
}

function initAttrTab() {
    $('.invertory-right__tab-child')[0].click();
}

function initEquipList() {
    for (let i = 0; i < 4; i++) {
        $('#inventory-left-item-list-1').append(`<div class="inventory-left__character-item" data-inventory-equid-list="${attrList[i].name}">${attrList[i].name}</div>`)
    }
    for (let i = 4; i < 8; i++) {
        $('#inventory-left-item-list-2').append(`<div class="inventory-left__character-item" data-inventory-equid-list="${attrList[i].name}">${attrList[i].name}</div>`)
    }
    
}
function sendDataToPhaser(parentAttr, currentAttr, isWear) {
    let obj = {};
    for (const [key, value] of visualItemInventory.entries()) {  

        if (key === parentAttr) {
            for (let i = 0; i < value.length; i++) {
                if (value[i].name === currentAttr) {
                    obj.name = value[i].name;
                    obj.partner = value[i].partner   
                }
            }
        }
    }
    //send data to iframe to change character accesories ui
    const message = {
        event_id: 'changingClothes',
        attrList:{
            items: obj,
            attrKey: parentAttr,
            isWear: isWear
        }
    };

    window.changingClothesObj = message;
    let iFrame = document.getElementById("MyFrame").contentWindow;
    iFrame.postMessage(message, "https://xelestech.com/townhubiframe/index.html");

    window.parent.postMessage(message, '*');
}

function initSendDataToPhaser(wearingList) {
    const message = {
        event_id: 'initChangingClothes',
        wearingList: wearingList
    };
    var iFrame = document.getElementById("MyFrame").contentWindow;
    iFrame.postMessage(message, "https://xelestech.com/townhubiframe/index.html");
}


initEquipList();
initAttrListRender();
$(document).on('keydown', function(event) {
    if (event.key == "Escape") {
        $('.inventory-container-close').click();
    }
});
$('.inventory-container-close').on("click", function(){
    $('.inventory-container')[0].classList.add('close')
    setTimeout(() => {
        $('.inventory-wrapper')[0].classList.add("hide");
    }, 500);
})
$('.inventory-right__items-child__close').on("click", function(event){
    let isWear = false;
    let parentAttr = $(this.parentElement.parentElement).attr("data-inventory-list");
    let currentAttr = $(this.parentElement).attr("data-inventory-list-child");

    $(`[data-inventory-equid-list="${parentAttr}"]`)[0].children[0].remove();
    this.parentElement.classList.remove("selected")

    $(`[data-inventory-equid-list="${parentAttr}"]`)[0].innerText = parentAttr;
    sendDataToPhaser(parentAttr, currentAttr, isWear);

    event.stopPropagation();
})
$('.inventory-right__items-child').on("click", function() {
    let parent = this.parentElement.children;
    let isWear = true;

    for (let i = 0; i < parent.length; i++) {
        parent[i].classList.remove('selected')
    }
    this.classList.add("selected");
    let currentAttr = $(this).attr("data-inventory-list-child");

    let parentAttr = $(this.parentElement).attr("data-inventory-list");
    
    $(`[data-inventory-equid-list="${parentAttr}"]`)[0].innerHTML = "";
    $($(`[data-inventory-equid-list="${parentAttr}"]`)[0]).append(`<img src="${API_ENDPOINT}/assets/inventory/acc/${currentAttr}.png">`)
    
    sendDataToPhaser(parentAttr,currentAttr,isWear)
});

$('.invertory-right__tab-child').on("click", function() {

    $('.invertory-right__tab-child').each(function(i, obj) {
        obj.classList.remove("selected");
    });

    this.classList.add("selected");
    let dataAttr = $(this).attr("data-attr");

    for (let i = 0; i < attrList.length; i++) {
        if (dataAttr === attrList[i].name) {
            $(`[data-inventory-list="${dataAttr}"`)[0].classList.add('show')
        } else {
            $(`[data-inventory-list="${ attrList[i].name}"`)[0].classList.remove('show')
        }
    }
})

//tab arrow click event
$('.invertory-right__tab-arrow').on("click", function() {
    let maxScrollWidth = $('.invertory-right__tabs-container').get(0).scrollWidth;
    let currentScrolLeft = $('.invertory-right__tabs-container').scrollLeft();
    let offsetWidth = $('.invertory-right__tabs-container')[0].offsetWidth;
    let dataVal = this.getAttribute("data-val");

    let maxScrollDivider = maxScrollWidth/offsetWidth + 1;
    if (dataVal === 'left') {   
            if (currentScrolLeft> offsetWidth -  offsetWidth/2 -10) {
            $('.invertory-right__tabs-container').animate( { scrollLeft: `-=${maxScrollWidth/maxScrollDivider}` }, 500);
            } 
        
    
    } else {
    

        if (currentScrolLeft< offsetWidth) {
            $('.invertory-right__tabs-container').animate( { scrollLeft: `+=${maxScrollWidth/maxScrollDivider}` }, 500);
        } else {
            // rightClickCount = 0;
        }
    }

})



initAttrTab();
}